import { render } from "./vragenlijst-component.vue?vue&type=template&id=113ea462"
import script from "./vragenlijst-component.vue?vue&type=script&lang=js"
export * from "./vragenlijst-component.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__